/**
 * Utility functions for getting app version information
 */

/**
 * Get the current build version from meta tag
 */
export const getBuildVersion = (): string | null => {
  const metaTag = document.querySelector('meta[name="build-time"]')
  const content = metaTag?.getAttribute('content')

  if (!content || content === 'BUILD_TIME_PLACEHOLDER') {
    return null
  }

  return content
}

/**
 * Parse build version into readable components
 */
export const parseBuildVersion = (version: string | null): {
  timestamp: string | null
  commitHash: string | null
  formattedDate: string | null
} => {
  if (!version) {
    return {
      timestamp: null,
      commitHash: null,
      formattedDate: null
    }
  }

  // Version format: "2025-01-24T12:34:56.789Z-abc1234"
  const parts = version.split('-')

  if (parts.length < 4) {
    return {
      timestamp: version,
      commitHash: null,
      formattedDate: null
    }
  }

  // Reconstruct ISO timestamp (YYYY-MM-DDTHH:MM:SS.SSSZ)
  const timestamp = parts.slice(0, -1).join('-')
  const commitHash = parts[parts.length - 1]

  let formattedDate = null
  try {
    const date = new Date(timestamp)
    formattedDate = date.toLocaleString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZoneName: 'short'
    })
  } catch (e) {
    // Invalid date format
  }

  return {
    timestamp,
    commitHash,
    formattedDate
  }
}
